import { render, staticRenderFns } from "./CompetencyDetail.vue?vue&type=template&id=4957bac7&scoped=true"
import script from "./CompetencyDetail.vue?vue&type=script&lang=js"
export * from "./CompetencyDetail.vue?vue&type=script&lang=js"
import style0 from "./CompetencyDetail.vue?vue&type=style&index=0&id=4957bac7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4957bac7",
  null
  
)

export default component.exports